import {createMuiTheme} from "@material-ui/core"

export default createMuiTheme({
    palette: {
        primary: {
            main: "#567cf6",
        },
        error: {
            main: "#fa5465",
        },
    },
})
